export enum NegotiationRateRole {
  WORKER = "WORKER",
  WORKPLACE = "WORKPLACE",
  ADMIN = "ADMIN",
  NEW_PROPOSAL = "NEW_PROPOSAL",
}

export enum NegotiationHistoryAction {
  INITIAL = "INITIAL",
  STARTED = "STARTED",
  PROPOSED = "PROPOSED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  BOOKED_BY_HCP = "BOOKED_BY_HCP",
  BOOKED_BY_ANOTHER_HCP = "BOOKED_BY_ANOTHER_HCP",
  BOOKED_CONFLICTING_SHIFT = "BOOKED_CONFLICTING_SHIFT",
  SHIFT_ASSIGNED_BY_ADMIN = "SHIFT_ASSIGNED_BY_ADMIN",
  HIDDEN = "HIDDEN",
  SHIFT_LEAD_TIME_EXPIRED = "SHIFT_LEAD_TIME_EXPIRED",
  WORKER_SUSPENDED = "WORKER_SUSPENDED",
  WORKPLACE_SUSPENDED = "WORKPLACE_SUSPENDED",
  WORKER_DEACTIVATED = "WORKER_DEACTIVATED",
  WORKPLACE_DEACTIVATED = "WORKPLACE_DEACTIVATED",
  WORKER_BLOCKED = "WORKER_BLOCKED",
  WORKPLACE_BLOCKED = "WORKPLACE_BLOCKED",
}

export interface RateNegotiationHistoryResponse {
  action: NegotiationHistoryAction;
  createdByUserId: string;
  createdByUserRole: NegotiationRateRole;
  payRate?: number;
  start?: string;
  end?: string;
  createdAt?: string;
}
